import React from "react";
import Card from "components/Card/Card";
import { useParams } from "react-router-dom";
import Page from "components/Page/Page";
import UpdateClinicForm from "./components/UpdateClinicForm";
import DetailSelector from "./components/DetailSelector";
import ProviderProfileForm from "./components/ProviderProfileForm";
import PaymentAccountCard from "./components/PaymentAccountCard";
import LocationForm from "./components/LocationForm";

const ClinicDetails = () => {
  const { id } = useParams();
  const orgId = id ? Number(id) : 0;

  return (
    <Page
      title="Provider Details"
      subTitle={id ? `Provider ID: ${id}` : "Edit provider information and manage related records"}
    >
      <div className="flex flex-col gap-5">
        <Card
          title="Provider settings"
          subTitle="Update the provider's name and currency."
        >
          <UpdateClinicForm />
        </Card>
        {orgId > 0 && (
          <Card
            title="Location"
            subTitle="Where you are. Families find you by the pin, and payments need your country."
          >
            <LocationForm orgId={orgId} />
          </Card>
        )}
        {orgId > 0 && (
          <Card
            title="Public profile"
            subTitle="What kind of provider you are, and what families see on the marketplace."
          >
            <ProviderProfileForm orgId={orgId} />
          </Card>
        )}
        {orgId > 0 && (
          <Card title="Payments" subTitle="How families pay you through Funely.">
            <PaymentAccountCard orgId={orgId} />
          </Card>
        )}
        <Card>
          <DetailSelector orgId={orgId} />
        </Card>
      </div>
    </Page>
  );
};

export default ClinicDetails;
